import { useParams } from "react-router-dom"

import Style from "./style"
import logo from "./asset/logo.svg"

import personalTerm from "shared/constant/term/personalTerm"
import serviceTerm from "shared/constant/term/serviceTerm"
import tryoutTerm from "shared/constant/term/tryoutTerm"

const Term = () => {
    const params = useParams()
    const type = params.type

    const termList = {
        "policy": {
            "title": "개인정보처리방침",
            "content": personalTerm || ""
        },
        "service": {
            "title": "서비스이용약관",
            "content": serviceTerm || ""
        },
        "tryout": {
            "title": "트라이아웃 프로 자격 시험 약관",
            "content": tryoutTerm || ""
        },
    }

    return (
        <Style.Wrapper>
            <img src={logo} />
            <Style.Title>{termList[type]?.title}</Style.Title>
            <Style.Content>{termList[type]?.content}</Style.Content>
        </Style.Wrapper>
    )
}

export default Term